"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("@date-io/luxon"); // This is only needed to satisfy types on build
var x_date_pickers_1 = require("@mui/x-date-pickers");
var react_i18next_1 = require("react-i18next");
var LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
var styles_1 = require("./styles");
var prism_icons_1 = require("@octanner/prism-icons");
var DatePicker = function (_a) {
    var dateAdapter = _a.dateAdapter, dateFormats = _a.dateFormats, dateLibInstance = _a.dateLibInstance, localeText = _a.localeText, adapterLocale = _a.adapterLocale, locale = _a.locale, renderInput = _a.renderInput, props = __rest(_a, ["dateAdapter", "dateFormats", "dateLibInstance", "localeText", "adapterLocale", "locale", "renderInput"]);
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(LocalizationProvider_1.LocalizationProvider, { dateAdapter: dateAdapter, adapterLocale: adapterLocale || locale || 'en-US', dateFormats: dateFormats, dateLibInstance: dateLibInstance, localeText: localeText },
        react_1.default.createElement(x_date_pickers_1.DatePicker, __assign({ inputFormat: "dd MMM yyyy", renderInput: renderInput ||
                (function (params) { return (react_1.default.createElement(styles_1.StyledTextField, __assign({}, params, { InputProps: __assign(__assign({}, params.InputProps), { readOnly: props.readOnly }), inputProps: __assign(__assign({}, params.inputProps), { placeholder: t('prism-header:datepicker-placeholder', 'DD MMM YYYY') }), helperText: t('prism-header:datepicker-helper-text', 'Enter date in DD MMM YYYY format') }))); }), components: {
                SwitchViewIcon: prism_icons_1.ArrowDown,
                LeftArrowIcon: prism_icons_1.ArrowLeft,
                RightArrowIcon: prism_icons_1.ArrowRight,
            }, InputAdornmentProps: {
                sx: styles_1.InputAdornmentStyles,
            }, PaperProps: {
                sx: styles_1.PaperStyles,
            }, DialogProps: {
                sx: styles_1.PaperStyles,
            } }, props))));
};
exports.default = DatePicker;
//# sourceMappingURL=DatePicker.js.map